import { Chip } from '@mui/material';
import dayjs from 'dayjs';
import StudentImpactOverview from '../../../../crd/myworkspace/ImpactReport/StudentImpactOverview';

const formatDate = (value) => (value ? dayjs(value).format('DD MMM YYYY') : '—');

export const retentionLeadsHeaderFn = () => [
  { field: 'sl_no', headerName: 'Sl No', width: 90 },
  { field: 'admn_no', headerName: 'Admission No', width: 180, sortable: true },
  { field: 'student_name', headerName: 'Student Name', width: 260, toolTipGetter: true, sortable: true },
  { field: 'student_mob_no', headerName: 'Phone Number', width: 170 },
  { field: 'class_name', headerName: 'Class', width: 120 },
  { field: 'course_name', headerName: 'Course', width: 280, toolTipGetter: true, sortable: true },
  {
    field: 'course_status',
    headerName: 'Student Status',
    width: 190,
    sortable: true,
    renderCell: ({ row, value }) => (
      <Chip
        size="small"
        label={value || '—'}
        variant="outlined"
        color={row?.course_enrollment_status === 1 ? 'success' : row?.course_enrollment_status === 2 ? 'warning' : 'error'}
      />
    ),
  },
  {
    field: 'course_inactive_date',
    headerName: 'Student Inactive Date',
    width: 200,
    valueGetter: ({ value }) => formatDate(value),
  },
  { field: 'previous_cro', headerName: 'Previous CRO', width: 220, toolTipGetter: true, sortable: true },
  { field: 'assigned_by', headerName: 'Handed Over By', width: 220, toolTipGetter: true, sortable: true },
  {
    field: 'assigned_on',
    headerName: 'Handed Over On',
    width: 190,
    sortable: true,
    valueGetter: ({ value }) => (value ? dayjs(value).format('DD MMM YYYY hh:mm A') : '—'),
  },
  { field: 'retention_remarks', headerName: 'CRM Remarks', width: 300, toolTipGetter: true },
  {
    field: 'overall_impact',
    headerName: 'Impact Report',
    width: 160,
    //SAME FULL SCREEN POPUP THE CRD IMPACT REPORT ANALYTICS TABLE USES . IT ONLY READS
    //admn_no / student_name / class_name OFF THE ROW , ALL OF WHICH A RETENTION LEAD ALREADY CARRIES ,
    //AND PULLS THE EXAMINATION OVERVIEW ITSELF BY ADMISSION NUMBER WHEN OPENED.
    renderCell: ({ row }) => <StudentImpactOverview row={row} />,
  },
];

export const RETENTION_STUDENT_STATUS_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: '1' },
  { label: 'Inactive', value: '0' },
  { label: 'Temporarily Inactive', value: '2' },
];
